import FieldsPayStubEmployeeInfoNew from './FieldsPayStubEmployeeInfoNew'

export default FieldsPayStubEmployeeInfoNew
